import { Map, Expression } from 'maplibre-gl';
import { Feature, FeatureCollection, Point } from "geojson";
import { LayerParams } from "../../map/layer-manager";
import { MapLayer } from "../map-layer";
import { UnsetColor } from "../unset-color";

/**
 * Camada dos polígonos dos bairros.
 */
export class NeighborhoodLayer extends MapLayer implements UnsetColor {

  constructor(private sourceId: string, private layerId: string) {
    super();
  }

  hasData(layerParams: LayerParams): boolean {
    let { neighborhoodsData } = layerParams;
    return neighborhoodsData != null && neighborhoodsData.features.length > 0;
  }

  remove(map: Map) {

    if (map.getLayer(this.layerId)) {
      map.removeLayer(this.layerId);
    }

    if (map.getSource(this.sourceId)) {
      map.removeSource(this.sourceId)
    }
  }

  /**
   * Exibe a camada dos bairros.
   * @param layerParams parâmetros de configuração da camada.
   */
  show(
    map: Map, 
    layerParams: LayerParams) {

    const { selectedTimestamp, calcNeighborhoods, neighborhoodsData } = layerParams;

    if (calcNeighborhoods == null) {

      map.addSource(this.sourceId, {
        'type': 'geojson',
        'data': neighborhoodsData,
        'promoteId': 'ogc_fid',
      });

      this.setMapFillLayer(
        map, 
        this.sourceId, 
        this.layerId,
        '#808080', 
        '#252525'
      );
      return;
    }

    // Colorindo os polígonos dos bairros
    neighborhoodsData.features.forEach(val => {
      let localData;
      localData = calcNeighborhoods.filter((data: Feature<Point>) => { return data.properties.nome_estacao_original == val.properties.name })
      val.properties.rain_color = localData[0].properties.color[selectedTimestamp];
    })

    map.addSource(this.sourceId, {
      'type': 'geojson',
      'data': neighborhoodsData
    });

    this.setMapFillLayer(
      map, 
      this.sourceId, 
      this.layerId, 
      ['get', 'rain_color'],
      '#252525'
    );
  }

  /**
   * set mapbox instance fill layer
   * @see https://docs.mapbox.com/mapbox-gl-js/example/geojson-polygon/
   * @param map mapbox instance which will be configured
   * @param dataSourceId data source exclusive identifier
   * @param dataLayerFillId fill type layer exclusive identifier
   * @param fillColor layer fill color
   * @param fillOpacity layer fill opacity
   */
  setMapFillLayer(map: Map, dataSourceId: string, dataLayerFillId: string,
    fillColor: string|Expression|any, lineColor: string) {
    // second, we add a type fill layer to 'paint' the regions on the map
    map.addLayer({
      id: dataLayerFillId,
      type: 'fill',
      source: dataSourceId,
      layout: {
        visibility: 'visible',
      },
      paint: {
        'fill-color': fillColor,
        'fill-outline-color': lineColor,
        'fill-opacity': 0.6,
      },
    });
  }

  unsetColor(map: Map, layerParams: LayerParams) {

    let { neighborhoodsData, active } = layerParams;

    neighborhoodsData.features.forEach(feature => {
      feature.properties.rain_color = '#808080';
    });

    this.remove(map);

    if (active == false) {
      return;
    }

    this.show(map, layerParams);
  }

}
